import uiRouter from '@uirouter/angularjs';

import { ExtensionServiceModule } from 'services/data/extension.service';

import './extension.scss';

export const ExtensionDirective = angular
    .module('app.components.extensions.extensionDirective', [
        uiRouter,
        ExtensionServiceModule
    ]).directive('extensions', ($rootScope, $compile, extensionService, $state) => {
        return {
            link: (scope, element, attrs) => {
                updateExtensions();

                $rootScope.$on('extensions:newinstalled', () => {
                    updateExtensions();
                });

                function updateExtensions() {
                    return extensionService.getExtensions(attrs.app)
                        .then((extensions) => {
                            let productUpdateHandlerAttr = '';
                            let preOrdersEnabledAttr = '';
                            let togglePreOrderAttr = '';
                            let setAvailabilityMessageAttr = '';
                            let validationChangedHandlerAttr = '';
                            element.html('');

                            if ($state.current.name === 'product.detail' || $state.current.name === 'product.add') {
                                productUpdateHandlerAttr = `update-product-handler="${attrs.updateProductHandler}"`;
                                validationChangedHandlerAttr = `on-validation-changed="${attrs.onValidationChanged}"`;
                                preOrdersEnabledAttr = `pre-orders-enabled="${attrs.preOrdersEnabled}"`;
                                togglePreOrderAttr = `toggle-pre-order="${attrs.togglePreOrder}"`;
                                setAvailabilityMessageAttr =
                                    `set-availability-message="${attrs.setAvailabilityMessage}"`;
                            }

                            angular.forEach(extensions, (extension) => {
                                let stateInjection = `page-state="${attrs.pageState}"`;
                                let extensionElement = angular.element(
                                    `<${extension.directive}
                                        model="${attrs.model}"
                                        ${stateInjection}
                                        ${productUpdateHandlerAttr}
                                        ${preOrdersEnabledAttr}
                                        ${togglePreOrderAttr}
                                        ${setAvailabilityMessageAttr}
                                        ${validationChangedHandlerAttr}>
                                    </${extension.directive}>`);
                                $compile(extensionElement)(scope);
                                element.append(extensionElement);
                            });

                            $rootScope.$emit('extensions:updated');
                        });
                }
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/extensions/extension.directive.js